import LocationPage, { LocationData } from './LocationPage';

const fortLauderdaleData: LocationData = {
  city: 'Fort Lauderdale',
  state: 'Florida',
  stateAbbr: 'FL',
  slug: 'fort-lauderdale',
  heroTitle: 'Streamline hiring in Fort Lauderdale',
  heroSubtitle: 'Fort Lauderdale businesses deserve better hiring tools. iHireFast automates applicant communication, scheduling, and tracking so you can focus on finding the right people.',
  metaDescription: 'iHireFast helps Fort Lauderdale businesses hire faster with automated emails, Calendly scheduling, application forms, and applicant tracking. Start free today.',
  industries: [
    { name: 'Marine & Yachting', icon: '⛵', description: 'Fort Lauderdale is the yachting capital of the world. Marine service companies, marinas, and boat builders are always hiring.' },
    { name: 'Hospitality & Tourism', icon: '🌴', description: 'Hotels along Fort Lauderdale Beach, restaurants on Las Olas, and event venues need reliable staff year-round.' },
    { name: 'Healthcare & Senior Care', icon: '🏥', description: 'Broward County\'s growing population drives constant demand for healthcare workers, nurses, and senior care staff.' },
    { name: 'Technology', icon: '💻', description: 'Fort Lauderdale\'s tech corridor along Cypress Creek is home to growing startups and established tech firms.' },
    { name: 'Construction', icon: '🏗️', description: 'Rapid development in downtown Fort Lauderdale and surrounding areas means high demand for skilled trades.' },
    { name: 'Education', icon: '📚', description: 'Broward County Public Schools and local universities are among the largest employers, with ongoing recruitment needs.' },
  ],
  stats: [
    { label: 'Avg. Time to Hire', value: '4 days' },
    { label: 'Response Rate', value: '92%' },
    { label: 'Broward Businesses', value: '150+' },
    { label: 'Applicants Processed', value: '3K+' },
  ],
  neighborhoods: [
    'Downtown Fort Lauderdale', 'Las Olas', 'Fort Lauderdale Beach', 'Victoria Park',
    'Flagler Village', 'Wilton Manors', 'Oakland Park', 'Lauderhill',
    'Plantation', 'Sunrise', 'Davie', 'Hollywood', 'Pembroke Pines',
    'Weston', 'Coral Springs', 'Pompano Beach', 'Deerfield Beach', 'Tamarac',
  ],
  testimonial: {
    quote: 'We manage 5 restaurants along Las Olas and hiring used to be a nightmare. Now applicants get an email within seconds and book their own interviews. We\'ve cut our time-to-hire by 60%.',
    name: 'James Rodriguez',
    role: 'Operations Manager',
    company: 'Las Olas Hospitality Group',
  },
  localInsight: 'Fort Lauderdale\'s economy is diversifying beyond tourism. With new tech companies, healthcare expansion, and a $2 billion downtown development boom, the competition for talent is fierce. Employers who respond to applicants first win.',
  jobMarketDescription: 'Broward County employs over 900,000 people across diverse industries. Fort Lauderdale is experiencing a renaissance with massive investment in downtown development, a growing tech sector, and continued strength in marine, tourism, and healthcare. The tight labor market means speed matters.',
};

export default function FortLauderdalePage() {
  return <LocationPage data={fortLauderdaleData} />;
}
